export default "__VITE_ASSET__461844cf__"